"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeAPI = void 0;
class TradeAPI {
    constructor(adapter, market) {
        this.apiAdapter = null;
        this.apiAdapter = adapter;
        this.market = market;
    }
    getExchangeName() {
        return this.market;
    }
    isTradePermissionEnabled(callback) {
        throw new Error("not implemented");
    }
    checkTradePermission(firstCheck) {
        throw new Error("not implemented");
    }
    getRawSymbols() {
        throw new Error("not implemented");
    }
    setExchangeSymbols(symbols) {
        throw new Error("not implemented");
    }
    getDefaultSymbols() {
        throw new Error("not implemented");
    }
    getSymbol(base, quote) {
        throw new Error("not implemented");
    }
    getTickerObservable(base, quote) {
        throw new Error("not implemented");
    }
    getDepthDataObservable(base, quote) {
        throw new Error("not implemented");
    }
    createOrderObservable(orderParam, callback) {
        throw new Error("not implemented");
    }
    cancelOrderObservable(orderData, info) {
        throw new Error("not implemented");
    }
    cancelAllOrderObservable(orderData) {
        throw new Error("not implemented");
    }
    getQueryGridDescObservable(base, quote, griOrderId) {
        throw new Error("not implemented");
    }
    getSpotOrder(symbol, id) {
        throw new Error("not implemented");
    }
    getQueryMarketAllBotOrders() {
        throw new Error("not implemented");
    }
    getQueryByStatusMarketBotOrders() {
        throw new Error("not implemented");
    }
    getWebSocketMarketBotOrders(exchange) {
        throw new Error("not implemented");
    }
    getQueryByStatusMarketBotOrdersMore(pageNo, pageNum, status, base, quote) {
        throw new Error("not implemented");
    }
    getQueryBotOrdersMoreV2(param) {
        throw new Error("not implemented");
    }
    getMarketBotOrdersCountByStatus(params) {
        throw new Error("not implemented");
    }
    queryTickerByRest(base, quote, market) {
        throw new Error("not implemented");
    }
    queryTickerWithSymbolList(symbolList) {
        throw new Error("not implemented");
    }
    stopRefreshGridDetailInfo() {
        throw new Error("not implemented");
    }
    queryCustomOrders(base, quote, queryOpen) {
        throw new Error("not implemented");
    }
    getTrades(base, quote) {
        throw new Error("not implemented");
    }
    askTradePermission() {
        throw new Error("not implemented");
    }
    queryTradePermission() {
        throw new Error("not implemented");
    }
    requestBotPoolData(orderType, exchange, base, quote) {
        throw new Error("not implemented");
    }
    requestMyBotData(orderType, exchange, base, quote) {
        throw new Error("not implemented");
    }
    copyTradingBot(botId) {
        throw new Error("not implemented");
    }
    requestStrategyScores() {
        throw new Error("not implemented");
    }
    requestGridProPairsBearishRatio(base, quote) {
        throw new Error("not implemented");
    }
    requestGridProfitData(type) {
        throw new Error("not implemented");
    }
    checkGridOrderCanCreate(request) {
        throw new Error("not implemented");
    }
    checkGridRequireBalance(bodyParam) {
        throw new Error("not implemented");
    }
    checkIGBalanceEnough(bodyParam) {
        throw new Error("not implemented");
    }
    refreshTradingLimitInfoWithSymbol(base, quote) {
        throw new Error("not implemented");
    }
    getTradingLimitForHuoBiPro(base, quote) {
        throw new Error("not implemented");
    }
    recoverGridOrder(orderId) {
        throw new Error("not implemented");
    }
    takeProfit(orderId) {
        throw new Error("not implemented");
    }
    getMarketWSTickerObservable(market, symbolList) {
        throw new Error("not implemented");
    }
    requireGridPervolume(bodyParam) {
        throw new Error("not implemented");
    }
    requireTopGridAIStrategy(market) {
        throw new Error("not implemented");
    }
    requireAIStrategyWithSymbol(market, base, quote) {
        throw new Error("not implemented");
    }
    requireIGAIStrategy(market, base, quote) {
        throw new Error("not implemented");
    }
    requireAITradePairWithMarket(market) {
        throw new Error("not implemented");
    }
    userDefineGridFeeRate(orderId, setToExchange, feeRate) {
        throw new Error("not implemented");
    }
    queryExchangeFeeRate(market, symbol) {
        throw new Error("not implemented");
    }
    getSymbolInfoObservable(base, quote) {
        throw new Error("not implemented");
    }
    querySymbolTicker(base, quote) {
        throw new Error("not implemented");
    }
    queryRestSymbolTicker(base, quote) {
        throw new Error("not implemented");
    }
    requireTopGridAIStrategyBatch(marketList) {
        throw new Error("not implemented");
    }
    requireAITradePairDetailWithMarket(market) {
        throw new Error("not implemented");
    }
    requireStableAIStrategyBatch(marketList) {
        throw new Error("not implemented");
    }
    requireMainStreamAIStrategyBatch(marketList) {
        throw new Error("not implemented");
    }
    requestCoinAddress(coin) {
        throw new Error("not implemented");
    }
    fetchDepositWithdrawHistory(coin, type, startTime) {
        throw new Error("not implemented");
    }
    fetchDepositWithdrawHistoryV2(coin, type, startTime) {
        throw new Error("not implemented");
    }
    withdraw(param) {
        throw new Error("not implemented");
    }
    withdrawV2(param) {
        throw new Error("not implemented");
    }
    cancelWithdraw(id) {
        throw new Error("not implemented");
    }
    requestAllBrokerCoins() {
        throw new Error("not implemented");
    }
    requestAllBrokerCoinsV2() {
        throw new Error("not implemented");
    }
    /**
     *
     * @param coinName
     * @param protocol
     */
    parseProtocolToDisplay(coinName, protocol) {
        throw new Error("not implemented");
    }
    fetchVerifyCode(verifyCodeType) {
        throw new Error("not implemented");
    }
    queryCustomOrderPage(queryParam, queryOpen, repeat) {
        throw new Error("not implemented");
    }
    getQueryAIPCustomOrdersOnce(orderId, pgno = 0, pgnm = 10) {
        throw new Error("not implemented");
    }
    getBotTypeBalance() {
        throw new Error("not implemented");
    }
    getQueryAllMarketBotOrdersMoreV2(param, allExchange) {
        throw new Error("not implemented");
    }
    requestMoveRecords(coin) {
        throw new Error("not implemented");
    }
    /**
     * 查询基金特权信息
     */
    getFundPrivilegeFundInfo() {
        throw new Error("not implemented");
    }
    /**
     * 获取open订单
     */
    getFundOpenOrders() {
        throw new Error("not implemented");
    }
    cancelFundOrder(orderId) {
        throw new Error("not implemented");
    }
    queryFundProfitData(fundCode) {
        throw new Error("not implemented");
    }
    queryFundProfitRecords(fundCode) {
        throw new Error("not implemented");
    }
    queryFundInvestmentRecords() {
        throw new Error("not implemented");
    }
    fundRedeemAll(symbol) {
        throw new Error("not implemented");
    }
    queryGridProBalanceSequence(orderType, orderId, period) {
        throw new Error("not implemented");
    }
    /**
     * enhanceAip 收益
     * @param orderType
     * @param orderId
     */
    queryGridProBalanceSequenceV2(orderType, orderId) {
        throw new Error("not implemented");
    }
    queryPionexFeeRate(base, quote) {
        throw new Error("not implemented");
    }
    getInnerApiKeyInfo() {
        throw new Error("not implemented");
    }
    // 获取资金池可借贷资金
    queryDeptAvaliable(coin) {
        throw new Error("not implemented");
    }
    // 获取杠杆交易信息
    queryLeverageTradeInfo(base, quote) {
        throw new Error("not implemented");
    }
    // 获取支持杠杆交易的配置信息
    queryLeverageSupportedConfig() {
        throw new Error("not implemented");
    }
    // 追加/提取保证金
    transferMargin(orderType, orderId, param) {
        throw new Error("not implemented");
    }
    // 获取支持杠杆交易的配置信息
    queryTradeLimit(minPrice, maxPrice, symbol) {
        throw new Error("not implemented");
    }
    queryAipBackTest(base, quote, exchange) {
        throw new Error("not implemented");
    }
    queryAipLimit(symbol, exchange) {
        throw new Error("not implemented");
    }
    queryFutureFundingRate(base, quote, exchange) {
        throw new Error("not implemented");
    }
    /**
     * 请求币安合约交易配置文件
     */
    requestBinanceLeverageConfigures(exchange) {
        throw new Error("not implemented");
    }
    /**
     * 请求永续合约交易所手续费
     */
    requestSwapFee() {
        throw new Error("not implemented");
    }
    queryTransferRecord(orderType, orderId, transfer_type) {
        throw new Error("not implemented");
    }
    queryTransferRecordV2(params) {
        throw new Error("not implemented");
    }
    /**
     * 查询Transfer 记录,包含分页信息, 特指保证金变更记录，主要是服务端接口不一致
     * @param params
     */
    queryTransferRecordV3(params) {
        throw new Error("not implemented");
    }
    /**
     * 合约追踪平仓
     * @param params
     */
    futuresSmartTradeClosePosition(params) {
        throw new Error("not implemented");
    }
    /**
     * 修改追踪参数
     * @param params
     */
    modifyFSTOrderTPSL(params) {
        throw new Error("not implemented");
    }
    transferProfit(orderType, orderId, param) {
        throw new Error("not implemented");
    }
    hedgeGridTransferProfit(orderId, param) {
        throw new Error("not implemented");
    }
    queryCurrentDayProfitAndLoss() {
        throw new Error("not implemented");
    }
    changeOrderTriggerPrices(params) {
        throw new Error("not implemented");
    }
    querySLProOrderList(params) {
        throw new Error("not implemented");
    }
    queryBotExchangeCloseOrderList(orderId, orderType, tag) {
        throw new Error("not implemented");
    }
    /**
     * @deprecated use queryGridPairedCloseOrderListV2
     */
    queryGridPairedCloseOrderList(orderId, orderType, pageToken, trend) {
        throw new Error("not implemented");
    }
    queryGridPairedCloseOrderListV2(params) {
        throw new Error("not implemented");
    }
    getQueryAllMarketBotOrdersMoreV3(params) {
        throw new Error("not implemented");
    }
    queryAllBotOrdersV4(params) {
        throw new Error("not implemented");
    }
    fetchFutureSymbolBalance(symbol) {
        throw new Error("not implemented");
    }
    /**
     * 获取币本位期现交易对信息
     */
    fetchFutureSpotFundingFeeRate() {
        throw new Error("not implemented");
    }
    fetchCoinMarginedFundingFeeRate() {
        throw new Error("not implemented");
    }
    fetchFutureSpotIncome(orderId, nextPageToken) {
        throw new Error("not implemented");
    }
    fetchOrderIncomes(orderId, orderType, nexPageToken, incomeTypeIn) {
        throw new Error("not implemented");
    }
    interruptFsaAdjustPosition(orderType, orderId) {
        throw new Error("not implemented");
    }
    hedgeGridCloseOrder(params) {
        throw new Error("not implemented");
    }
    getSpotAndFundTodayInitAsset() {
        throw new Error("not implemented");
    }
    convertStableCoin(source, target, sourceAmount) {
        throw new Error("not implemented");
    }
    querySymbolStatus(symbol) {
        throw new Error("not implemented");
    }
    queryCoinTransferInfo() {
        throw new Error("not implemented");
    }
    fetchPionexStrategyBalance(strategyId) {
        throw new Error("not implemented");
    }
    fsaRiskPlanStatus() {
        throw new Error("not implemented");
    }
    joinFSARiskPlan() {
        throw new Error("not implemented");
    }
    querySROrderRecords(param) {
        throw new Error("not implemented");
    }
    querySymbolsStatus() {
        throw new Error("not implemented");
    }
    queryManualOrders(param) {
        throw new Error("not implemented");
    }
    queryBotOrderCount() {
        throw new Error("not implemented");
    }
    getAllReleaseProfit() {
        throw new Error("not implemented");
    }
    modifySRBotName(name, orderType, orderId) {
        throw new Error("not implemented");
    }
    modifySRRules(param, orderType, orderId) {
        throw new Error("not implemented");
    }
    smartRebalanceUpdatePortfolio(orderId, portfolio, allocateOut) {
        throw new Error("not implemented");
    }
    querySRModifyCoinRecord(orderId) {
        throw new Error("not implemented");
    }
    allocateSRSmallBalance(orderId) {
        throw new Error("not implemented");
    }
    /**
     * 查询存币生息支持的币种
     * @param coin
     */
    queryFMCoins(coin) {
        throw new Error("not implemented");
    }
    /**
     * 存币生息申购
     * @param param
     */
    investFMCoin(param) {
        throw new Error("not implemented");
    }
    /**
     * 查询单笔申购
     * @param recordId
     */
    queryFMCoinInvest(recordId) {
        throw new Error("not implemented");
    }
    /**
     * 存币生息赎回
     * @param param
     */
    redeemFMCoin(param) {
        throw new Error("not implemented");
    }
    /**
     * 查询单笔赎回
     * @param recordId
     */
    queryFMCoinRedeem(recordId) {
        throw new Error("not implemented");
    }
    /**
     * 查询申赎记录
     * @param param
     */
    queryFMTransactions(param) {
        throw new Error("not implemented");
    }
    /**
     * 查询存币生息持仓
     */
    queryFMPositions() {
        throw new Error("not implemented");
    }
    /**
     * 存币生息提取利息
     * @param param
     */
    releaseFMInterest(param) {
        throw new Error("not implemented");
    }
    /**
     * 查询存币生息利息记录
     * @param param
     */
    queryFMInterestRecord(param) {
        throw new Error("not implemented");
    }
    /**
     * 查询利息总览
     */
    queryFMInterestAggregate() {
        throw new Error("not implemented");
    }
    /**
     * 查询MTG 当前挂单
     * @param orderId
     */
    queryMTGCurrentRound(orderId) {
        throw new Error("not implemented");
    }
    /**
     * 查询多币MTG 当前挂单
     * @param orderId
     */
    queryMTGMultiModeCurrentRounds(orderId) {
        throw new Error("not implemented");
    }
    /**
     * 查询MTG 历史挂单
     * @param param
     */
    queryMTGRoundList(param) {
        throw new Error("not implemented");
    }
    /**
     * 查询合约马丁 当前挂单
     * @param orderId
     */
    queryMTGFuturesCurrentRound(orderId) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询合约马丁 历史挂单
     * @param param
     */
    queryMTGFuturesRoundList(param) {
        throw new Error("Method not implemented.");
    }
    /**
     * 根据id 查询order
     * @param orderId
     */
    queryBotOrderInfo(orderId) {
        throw new Error("not implemented");
    }
    /**
     * 更新币本位套利自动结算
     * @param autoSettle
     * @param orderId
     */
    patchFSAAutoSettle(autoSettle, orderId) {
        throw new Error("not implemented");
    }
    /**
     * 设置马丁涨破多少不再补仓的价格
     * @param orderId
     * @param base
     * @param modifyPriceType
     * @param modifyValue
     */
    configureMartingaleStopPriceRange(orderId, base, range) {
        throw new Error("not implemented");
    }
    setMartingaleStopPrice(orderId, base, modifyPriceType, modifyValue) {
        throw new Error("not implemented");
    }
    /**
     * 获取马丁格尔AI参数
     * @param base
     * @param quote
     */
    requestMTGAIStrategyWithSymbol(base, quote) {
        throw new Error("not implemented");
    }
    /**
     * 多币马丁AI参数
     * @param pairs
     */
    requestMTGMultiAIStrategyWithSymbols(pairs) {
        throw new Error("not implemented");
    }
    /**
     * 多币马丁最小投资额
     * @param param
     */
    queryMTGMultiMinInvest(param) {
        throw new Error("not implemented");
    }
    /**
     * 重启马丁格尔这一轮
     * @param orderId
     */
    renewMartingale(orderId, base) {
        throw new Error("not implemented");
    }
    /**
     * 修改订单笔记
     * @param orderId
     * @param note
     */
    modifyBotOrderNote(orderId, note, orderType) {
        throw new Error("not implemented");
    }
    /**
     * 修改囤币宝止盈止损价格
     * @param param
     * @param orderId
     */
    modifySRPriceInfo(param, orderId) {
        throw new Error("not implemented");
    }
    /**
     * 修改多币马丁止盈止损比例
     * @param data
     * @param orderId
     */
    editStopRatio(data, orderId) {
        throw new Error("not implemented");
    }
    /**
     * 查询闲置资金
     * @param orderId
     * @param orderType
     */
    idleFunds(orderId, orderType) {
        throw new Error("not implemented");
    }
    /**
     * 查询闲置资金
     * @param orderId
     * @param orderType
     */
    queryIdleFunds(orderId, orderType) {
        throw new Error("not implemented");
    }
    /**
     * 设置网格订单暂停
     * @param orderId
     * @param orderType
     */
    setGridPause(orderId, orderType, data) {
        throw new Error("not implemented");
    }
    /**
     * 设置网格订单恢复
     * @param orderId
     * @param orderType
     */
    setGridResume(orderId, orderType) {
        throw new Error("not implemented");
    }
    /**
     * 收藏订单参数的增, 删, 查
     */
    saveOrderFavParams(type, title, data) {
        throw new Error("not implemented");
    }
    deleteOrderFavParams(id, type) {
        throw new Error("not implemented");
    }
    orderFavParamsList(type) {
        throw new Error("not implemented");
    }
    /**
     * 查询网格最小加仓金额
     * @param param
     * @param orderType
     */
    queryGridMinAddPosition(param, orderType) {
        throw new Error("not implemented");
    }
    /**
     * 获取网格订单仓位变更记录
     * @param orderId
     * @param orderType
     */
    queryGridPositionRecordList(orderId, orderType) {
        throw new Error("not implemented");
    }
    /**
     * 获取网格订单仓位变更记录支持分页
     * @param param
     */
    queryGridPositionRecordListV2(param) {
        throw new Error("not implemented");
    }
    /**
     * 获取利润复投记录
     * @param param
     */
    queryGridReinvestList(param) {
        throw new Error("not implemented");
    }
    /**
     * 设置自动复投开启关闭
     * @param param
     */
    switchProfitAutoReinvest(param) {
        throw new Error("not implemented");
    }
    queryOrderShareID(orderId) {
        throw new Error("not implemented");
    }
    queryOrderShare(shareId, ignoreParseOrderTypes) {
        throw new Error("not implemented");
    }
    gridAdjustParams(param) {
        throw new Error("not implemented");
    }
    /**
     * gridv4网格订单修改参数
     * @param param
     */
    gridV4AdjustParams(param) {
        throw new Error("not implemented");
    }
    getQueryGridBasicInfoObservable(griOrderId, orderType) {
        throw new Error("not implemented");
    }
    queryGridOrderBasicByIdWithRestApi(gridOrderId, orderType) {
        throw new Error("not implemented");
    }
    /**
     * @deprecated 已废弃, instead by queryDCACustomOrders
     */
    queryAIPOrTWAPCustomOrdersOnce(orderId, pgno = 0, pgnm = 10) {
        throw new Error("not implemented");
    }
    queryDCACustomOrders(orderId, pageToken) {
        throw new Error("not implemented");
    }
    requestLoanRecords(bu_order_id, page, page_size) {
        throw new Error("not implemented");
    }
    getQueryGridOpenOrdersObservable(gridOrderId, orderType, trend) {
        throw new Error("not implemented");
    }
    /**
     * 查询查询策略可用的信号
     */
    querySignalList(orderType, base, quote, signal_type) {
        throw new Error("not implemented");
    }
    /**
     * 查询策略可用的信号
     */
    queryMultiCoinsSignalList(orderType, symbols, filter_option_all_symbols, signal_type) {
        throw new Error("not implemented");
    }
    /**
     * 查询信号详情
     * @param signal_type
     */
    querySignalDetail(signal_type) {
        throw new Error("not implemented");
    }
    queryVolatilityRank(param) {
        throw new Error("not implemented");
    }
    /**
     * 查询KOL策略列表
     * @param lang
     * @param page_token
     * @param condition
     * @param category
     * @param enable_all_period
     * @param authorize
     */
    queryKolStrategy(lang, page_token, condition, category, enable_all_period, authorize) {
        throw new Error("not implemented");
    }
    /**
     * 查询KOL策略信号列表
     * @param strategyId
     * @param page_token
     */
    queryKolStrategySignals(strategyId, page_token) {
        throw new Error("not implemented");
    }
    /**
     * 查询KOL策略历史信号列表
     * @param strategyId
     * @param symbol
     * @param lang
     */
    queryKolStrategyHistorySignals(strategyId, symbol, lang) {
        throw new Error("not implemented");
    }
    /**
     * 查询KOL策略详情
     * @param strategyId
     * @param lang
     * @param enable_all_period
     */
    queryKolStrategyDetail(strategyId, lang, enable_all_period) {
        throw new Error("not implemented");
    }
    /**
     * 修改KOL信号通知 下面参数二选一
     * @param strategyId
     * @param signalId
     * @param bu_order_id
     * @param bu_order_type
     */
    updateStrategySignals(strategyId, signalId, bu_order_id, bu_order_type) {
        throw new Error("not implemented");
    }
    /**
     * 订阅kol信号
     * @param strategyId
     * @param symbol
     */
    subscribeStrategySignals(strategyId, symbol) {
        throw new Error("not implemented");
    }
    /**
     * 取消订阅kol信号
     * @param strategyId
     */
    unsubscribeStrategySignals(strategyId) {
        throw new Error("not implemented");
    }
    /**
     *  更新kol 信号订阅币对
     * @param strategyId
     * @param symbol
     */
    updateSubscribeStrategySignals(strategyId, symbol) {
        throw new Error("not implemented");
    }
    /**
     * 获取策略信号收益表现图表详情
     * @param strategyId
     * @param period
     */
    queryStrategyPerformance(strategyId, period) {
        throw new Error("not implemented");
    }
    /**
     * 查询订阅信号详情
     * @param strategyId
     */
    queryStrategySubscriptionInfo(strategyId) {
        throw new Error("not implemented");
    }
    /**
     * 查询特定的信号
     * @param strategyId
     * @param params
     */
    queryStrategySignal(strategyId, params) {
        throw new Error("not implemented");
    }
    /**
     * 通过信号id查询定的信号
     * @param strategyId
     * @param signalId
     */
    queryStrategySignalById(strategyId, signalId) {
        throw new Error("not implemented");
    }
    /**
     * 查询策略跟单历史交易记录
     * @param params
     */
    querySmartCopyRounds(params) {
        throw new Error("not implemented");
    }
    /**
     * 修改策略跟单是否开启复利
     * @param params
     */
    modifySmartCopyCompound(params) {
        throw new Error("not implemented");
    }
    /**
     * 策略跟单 手动平仓
     */
    manuallyLiquidateSCPosition(params) {
        throw new Error("Method not implemented.");
    }
    /**
     * 修改网格的移动网格配置
     * @param params
     * @param orderId
     * @param orderType
     */
    modifyGridMovingOption(params, orderId, orderType) {
        throw new Error("not implemented");
    }
    /**
     * 获取最大单网格买入量
     * @param params
     * @param orderType
     */
    queryGridMaxPerVolume(params, orderType) {
        throw new Error("not implemented");
    }
    /**
     * 获取AI策略列表
     * @param params
     */
    queryGridV4AiStrategyList(params) {
        throw new Error("not implemented");
    }
    queryGridV5AiStrategyList(params) {
        throw new Error("not implemented");
    }
    /**
     修改机器人 订单名称
     * @param name
     * @param orderType
     * @param orderId
     */
    modifyOrderBotName(name, orderType, orderId) {
        throw new Error("not implemented");
    }
    /**
     * 修改策略跟单止盈止损比例
     * @param param
     * @param orderId
     * @returns
     */
    modifySCStopRatio(param, orderId) {
        throw new Error("not implemented");
    }
    /**
     * 订单分组创建
     * @param params
     */
    createOrderGroup(params) {
        throw new Error("not implemented");
    }
    /**
     * 订单分组修改绑定数组
     * @param params
     * @constructor
     */
    OrderGroupBindOrder(params) {
        throw new Error("not implemented");
    }
    /**
     * 订单分组解绑
     * @param group_id
     * @constructor
     */
    OrderGroupUnBindOrder(group_id) {
        throw new Error("not implemented");
    }
    /**
     * 支持订单分组的bot订单列表
     * @param params
     */
    queryAllBotOrdersV5(params) {
        throw new Error("not implemented");
    }
    /**
     * 根据分组id查询分组内部订单列表
     * @param group_id
     * @param page_token
     * @param status
     */
    queryGroupOrderList(group_id, page_token, status) {
        throw new Error("not implemented");
    }
    /**
     * 根据分组id查询分组详情
     * @param group_id
     */
    queryGroupOrderDetail(group_id) {
        throw new Error("not implemented");
    }
    /**
     * 仅通过通过id和type,取消订单
     * @param orderId
     * @param orderType
     * @param info
     */
    cancelOrderObservableById(orderId, orderType, info) {
        throw new Error("not implemented");
    }
    /**
     * 查询bot策略单数量
     */
    queryBotOrderCountV2() {
        throw new Error("not implemented");
    }
    /**
     * 订单分组重命名
     * @param params
     */
    OrderGroupRenameOrder(params) {
        throw new Error("not implemented");
    }
    /**
     * 获取可用额度
     * @param params
     */
    queryFSTMaxLimit(params) {
        throw new Error("not implemented");
    }
    /**

     * 修改触发价/止盈止损
     * @param params
     */
    editTriggerPrice(orderId, params) {
        throw new Error("not implemented");
    }
    editOrderTriggerPrice(params) {
        throw new Error("not implemented");
    }
    /**
     * 更新自动跟单订单字段
     */
    editCopyBotOrderInfo(params) {
        throw new Error("not implemented");
    }
    /**
     * 获取跟随者
     */
    getCopyBotOrderFollowers(params) {
        throw new Error("not implemented");
    }
    /**
     * 获取分润详情
     */
    getCopyBotOrderShareSettledProfit(params) {
        throw new Error("not implemented");
    }
    /**
     * 获取操作记录
     */
    getCopyBotOrderOperationList(params) {
        throw new Error("not implemented");
    }
    /**
     * 立即触发
     * @param params
     */
    orderImmediateTrigger(orderId, params) {
        throw new Error("not implemented");
    }
    queryGridOverview(params) {
        throw new Error("not implemented");
    }
    setGridCloseSellModel(params) {
        throw new Error("not implemented");
    }
    /**
     * @description: 获取可用订单数量额度 https://pionex.atlassian.net/wiki/spaces/backend/pages/50731121/smart+copy+API#%E8%8E%B7%E5%8F%96%E5%8F%AF%E7%94%A8%E8%AE%A2%E5%8D%95%E6%95%B0%E9%87%8F%E9%A2%9D%E5%BA%A6
     * @return {*}
     */
    fetchSmartCopyCheck() {
        throw new Error("not implemented");
    }
    fetchOrderNotificationList(params) {
        throw new Error("not implemented");
    }
    copyBotOrderBatchClose(params) {
        throw new Error("not implemented");
    }
    queryCopyBotOverView(orderId) {
        throw new Error("not implemented");
    }
    queryCopyTransactionRecord(params) {
        throw new Error("not implemented");
    }
}
exports.TradeAPI = TradeAPI;
